import * as React from "react";

import { FileViewerModal } from "./FileViewerModal";
import { IconButton } from "./buttons/IconButton";
import { Loading } from "./base/Loading";
import { cn } from "./ClassName";

interface Props {
  file: File;
  deleteFile: (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent> | React.KeyboardEvent,
  ) => void;
  className?: string;
  isLoading?: boolean;
  hasError?: boolean;
}

/**
 * Basically a copy of shared component <SelectedFile>
 * but has display options and isn't a shared component.
 */
export function UploadedFile({
  file,
  deleteFile: onDeleteFile,
  className = "",
  isLoading = false,
  hasError = false,
}: Props) {
  const [showFileViewer, setShowFileViewer] = React.useState(false);
  const fileSizeMegabytes = file.size / 1048576;
  const numDecimalDigits = fileSizeMegabytes < 1 ? 2 : 1;

  return (
    <div
      className={cn(
        "tw-grid tw-grid-cols-12 tw-rounded-md tw-border-[0.5px] tw-border-solid tw-px-3 tw-py-2",
        hasError
          ? "tw-border-red-1 tw-bg-red-light-1"
          : "tw-border-gray-5 tw-bg-white",
        className,
      )}
      title={file.name}
    >
      <span className="tw-col-span-1 tw-inline-flex tw-place-items-center tw-text-[14px]">
        <i
          className={cn(
            "fa tw-mr-2",
            hasError
              ? "fa-circle-exclamation tw-text-red-1"
              : "fa-circle-check tw-text-green-1",
          )}
        />
      </span>
      <div className="tw-col-span-10 tw-flex tw-flex-col tw-justify-center tw-text-[14px]">
        <span className="tw-overflow-hidden tw-text-ellipsis tw-whitespace-nowrap tw-font-bold">
          {file.name}
        </span>
        <div className="tw-text-[12px] tw-font-normal">
          <span className="tw-text-gray-3">
            {`${fileSizeMegabytes.toFixed(numDecimalDigits)}MB`}
          </span>
          <button
            className="tw-ml-3 tw-h-auto tw-w-auto tw-border-none tw-bg-transparent tw-p-0 tw-text-blue-1 tw-underline hover:tw-bg-transparent"
            onClick={() => setShowFileViewer(true)}
          >
            preview
          </button>
        </div>
      </div>
      <span className="tw-col-span-1 tw-inline-flex tw-place-items-center tw-justify-end">
        {isLoading && <Loading size={14} />}

        <IconButton
          className="tw-ml-3 tw-h-auto tw-w-auto tw-p-0 tw-text-[14px]"
          icon="fa fas fa-trash-can"
          onClick={onDeleteFile}
        />
      </span>
      {showFileViewer && (
        <FileViewerModal
          file={file}
          hideFileViewer={() => setShowFileViewer(false)}
        />
      )}
    </div>
  );
}
